import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const Vacunacion = ({
    allowedWrite,
    isNew,
    datosSeleccionFormData,
    handleChange,
    handlePreview,
    handleChangeArchivo,
    handleDelete,
}) => {
    useEffect(() => {
        handleChange('certificadoVacunacionCheck', datosSeleccionFormData?.certificadoVacunacion?.length > 0);
    }, [datosSeleccionFormData?.certificadoVacunacion]);

    return (
        <div className='generic-tab-container container-separate'>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <div className='generic-header-tab-content-with-buttons'>
                        <strong>Vacunación</strong>
                    </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'custom_switch',
                            name: 'certificadoVacunacionCheck',
                            displayName: 'Vacunación/Dosaje',
                            disabled: true
                        }}
                        handleChange={handleChange}
                        value={datosSeleccionFormData.certificadoVacunacionCheck}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'file',
                            name: 'certificadoVacunacion',
                            displayName: 'Adjuntar',
                            disabled: !allowedWrite
                        }}
                        handleChange={handleChangeArchivo}
                        handleDelete={handleDelete}
                        value={datosSeleccionFormData.certificadoVacunacion}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'long_string',
                            name: 'observacionVacunacion',
                            displayName: 'Observación',
                            disabled: !allowedWrite
                        }}
                        handleChange={handleChange}
                        value={datosSeleccionFormData.observacionVacunacion}
                    />
                </Grid>
            </Grid>
        </div>
    );
}